<template>
    <row align="center" wrap-reversed>
        <column md="1/2" sm="full" xs="full">
            <component
                :class="mobile ? 'w-screen transform -translate-x-6' : ''"
                :custom-buttons="!mobile"
                :is="twCarousel"
                :options="{pageDots: mobile}"
                :style="{
                    'max-height': mobileSmall ? '310px' : mobile ? '350px' : '395px',
                    'min-height': mobileSmall ? '310px' : mobile ? '350px' : '395px'
                }"
                class="overflow-y-hidden"
                ref="carousel"
                v-if="twCarousel"
            >
                <div :class="mobile ? 'w-1/2' : 'w-full'" :key="index" v-for="(chunk, index) in chunkedTalents">
                    <column :key="colIndex"
                            cols="full"
                            v-for="(row, colIndex) in chunk"
                    >
                        <!--                        :justify="eight || six ? 'space-between' : four ? 'space-around' : 'center'"-->
                        <row :class="colIndex === 0 ? 'mb-10' : ''"
                             justify="center"
                             no-wrap
                        >
                            <!--                            :class="eight || six ? index === 0 ? 'mr-4' : index === row.length - 1 ? 'ml-4' : 'mx-4' : index === 0 ? 'mr-2' : index === row.length - 1 ? 'ml-2' : 'mx-2'"-->
                            <column :cols="eight ? '1/4' : six ? '1/3' : four ? '1/2' : 'full'"
                                    :key="index"
                                    align="center"
                                    v-for="(item, index) in row"
                            >
                                <card :height="mobileSmall ? '140' : mobile ? '160' : '180'"
                                      :width="mobileSmall ? '140' : mobile ? '160' : '180'"
                                      class="text-center fitt-framework-card"
                                      color="transparent"
                                      flat
                                      no-padding
                                      round
                                      style="border: 20px solid rgba(1, 116, 234, 1);"
                                >
                                    <div class="w-full h-full bg-white rounded-full flex item-center justify-center">
                                        <div
                                            class="flex
                                           items-center
                                           justify-center
                                           text-secondary
                                           tracking-normal
                                           leading-snug"
                                            v-html="item"
                                        ></div>
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </div>
            </component>
        </column>
        <column class="sm:pl-24 xs:mb-4 sm:mb-0" md="1/2" xs="full">
            <row justify="center">
                <div
                    class="text-secondary text-left h-full poppins-bold tracking-normal leading-very-high text-5xl">
                    <divider color="primary" width="56"></divider>
                    <div class="mt-3">
                        Construct a Total
                        <br>
                        Talent View
                    </div>
                </div>
            </row>
        </column>
    </row>
</template>

<script>
    import Helpers from "../../mixins/Helpers";

    export default {
        name: "TalentPager",
        mixins: [Helpers],
        props: {
            talents: {type: Array, required: true}
        },
        components: {
            card: () => import('@/components/Card.vue'),
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
            divider: () => import('@/components/Divider.vue'),
        },
        data: () => ({
            chunkedTalents: [],
            page: 0,
            innerWidth: 0,
            twCarousel: null
        }),
        computed: {
            eight() {
                return this.innerWidth > 1680;
            },
            six() {
                return (this.innerWidth <= 1680 && this.innerWidth > 1234);
            },
            four() {
                return this.innerWidth <= 1235 && this.innerWidth > 422;
            },
            mobile() {
                return this.innerWidth <= 421;
            },
            mobileSmall() {
                return this.innerWidth <= 360;
            }
        },
        methods: {
            parseTalents() {
                this.chunkedTalents = [];
                let pageAmount, splitAmount;
                if (this.eight) {
                    pageAmount = 8;
                    splitAmount = 4;
                } else if (this.six) {
                    pageAmount = 6;
                    splitAmount = 3;
                } else if (this.four) {
                    pageAmount = 4;
                    splitAmount = 2;
                } else {
                    pageAmount = 2;
                    splitAmount = 1;
                }
                let chunks = Array.from({
                    length: Math.ceil(this.talents.length / pageAmount)
                }, (v, i) => this.talents.slice(i * pageAmount, i * pageAmount + pageAmount));
                chunks.forEach((chunk) => {
                    this.chunkedTalents.push(
                        Array.from({
                            length: Math.ceil(chunk.length / splitAmount)
                        }, (v, i) => chunk.slice(i * splitAmount, i * splitAmount + splitAmount))
                    )
                });
                setTimeout(() => {
                    if(this.$refs.carousel) {
                        this.$refs.carousel.reRender();
                    }
                }, 1000);
            },
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
                this.parseTalents();
            }
        },
        mounted() {
            import('@/components/TwCarousel.vue').then((module) => {
                this.twCarousel = module.default;
                this.$nextTick().then(() => {
                    this.setInnerWidth();
                });
            });
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>
    .hover:hover {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        transition: background-color 0.2s;
    }

    .fitt-framework-card {
        position: relative;
    }
</style>